// script to add alt descriptions
window.addEventListener("load", () => {
    let idx = 1;
    const productName = ShopifyAnalytics.meta.product.variants[0].name;
    document.querySelectorAll(".product-single__description img").forEach((img) => {
        if (img.getAttribute("alt")) {
            return;
        }
        img.setAttribute("alt", "Image showing " + productName + " #" + idx);
        idx++;
    });
});
